import Stack from '@mui/material/Stack';
import { ReactElement, useState } from 'react';
import { Index } from 'react-instantsearch';
import { EmptySearch } from '@core/journeys/ui/EmptySearch';
import { ResourceSection } from './ResourceSection';
interface ResourceSectionsProps {
  includeIndex?: boolean;
}
export const indexes = [`${process.env.NEXT_PUBLIC_ALGOLIA_WP_PREFIX}_posts_equipment`, `${process.env.NEXT_PUBLIC_ALGOLIA_WP_PREFIX}_posts_training_strategies`, `${process.env.NEXT_PUBLIC_ALGOLIA_WP_PREFIX}_posts_outreach_resources`, `${process.env.NEXT_PUBLIC_ALGOLIA_WP_PREFIX}_posts_digital_strategies`, `${process.env.NEXT_PUBLIC_ALGOLIA_WP_PREFIX}_posts_prayer_resources`];
export function ResourceSections({
  includeIndex = false
}: ResourceSectionsProps): ReactElement {
  const [hasResult, setHasResult] = useState<boolean>(true);
  const resultsMap = new Map<number, boolean>();
  function handleItemSearch(index: number, hasResult_0: boolean): void {
    resultsMap.set(index, hasResult_0);
    const hasAnyResults = Array.from(resultsMap.values()).some(value => value);
    setHasResult(hasAnyResults);
  }
  return <Stack data-testid="ResourceSections" sx={{
    pt: 0,
    gap: 10
  }}>
      {!hasResult && <EmptySearch />}
      {includeIndex ? <Index indexName={indexes[0]}>
          <ResourceSection index={0} handleItemSearch={handleItemSearch} />
          {indexes.slice(1).map((indexName, index_0) => <Index key={index_0} indexName={indexName}>
              <ResourceSection index={index_0 + 1} handleItemSearch={handleItemSearch} />
            </Index>)}
        </Index> : <>
          {indexes.map((indexName_0, index_1) => <ResourceSection key={indexName_0} index={index_1 + 1} handleItemSearch={handleItemSearch} />)}
        </>}
    </Stack>;
}